import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link
} from '@material-ui/core';
import {
  createMuiTheme,
  MuiThemeProvider
} from '@material-ui/core/styles';

import { PublicNavbar } from '../../components/Navbars';

const theme = createMuiTheme({
  overrides: {
    MuiTypography: {
      root: {
        margin: '2rem 0'
      }
    }
  }
});

const PrivacyPolicy = () => {
  return (
    <>
      <PublicNavbar />

      <MuiThemeProvider theme={theme}>
        <Container>
          <Box pb={3}>
            <Typography variant="h4" align="center">
              Privacy Policy
            </Typography>

            <Typography>
              When you provide your personal information to Kingsland University, it will be used for the administrative or educational purposes of the University, in accordance with specific consent given by you, or as otherwise allowed under the Privacy Act 1988. The University will not make available to a third party any personal information supplied by you unless you have consented or the disclosure is otherwise permitted or required by law.
            </Typography>

            <Typography>
              The University may distribute aggregated statistical information for statutory reporting purposes but only in a form that will not identify any person individually.
            </Typography>

            <Typography variant="h6">
              Digital Logs And Analytics
            </Typography>

            <Typography>
              As with most websites or other digital properties, when accessing the University’s channels, log files are generated by the servers that show visitor details such as IP address, date, time and pages visited or documents downloaded. Information in these logs may used to generate statistical reports about access to University sites.
            </Typography>

            <Typography variant="h6">
              Cookie Use
            </Typography>

            <Typography>
              Kingsland uses digital cookies to deliver you a personalised experience on its websites. Cookies are text files saved on your computer’s hard drive and used to store small pieces of data.
            </Typography>

            <Typography>
              Analytics services, including <Link href="https://accounts.google.com/ServiceLogin?service=analytics&userexp=signup&hl=en">Google Analytics</Link>, use cookies which transmit information on your use of the website to a cloud service that may not be within your area of use. Google may also transfer this information to third parties where required by law, or where such third parties process the information on Google’s behalf. Kingsland uses Google Analytics and other analytics services for the purpose of evaluating online activity and improving your personalised experience online.
            </Typography>

            <Typography>
              By using this website or other University digital channels, you consent to the processing of data about you by Google in the manner and for the purposes set out above. You may refuse the use of cookies by selecting the appropriate settings on your browser; however, please note if you do this you may not be able to use the full functionality of this website or receive a personalised experience.
            </Typography>

            <Typography variant="h6">
              Secure Socket Layer (SSL) Encryption
            </Typography>

            <Typography>
              Certain University websites may use SSL encryption to provide a more secure method of transferring personal information such as passwords or contact details.
            </Typography>

            <Typography variant="h6">
              Opting Out Of Communications
            </Typography>

            <Typography>
              Kingsland University ensures when sending out direct marketing communication that you are able to opt out of future communications. There are links provided in such communication enabling you to unsubscribe or to email the sender to request your details be removed. On social media channels, each platform provides guidelines on how to opt out of future communications, in accordance with their relevant privacy statements.
            </Typography>

            <Typography variant="h6">
              Social Media
            </Typography>

            <Typography>
              The University website may also employ Facebook Insights. This provides aggregated, non-personally identifiable information to page owners and platform developers. For more information about privacy on Facebook, refer to the <Link href="https://www.facebook.com/privacy/explanation">Facebook privacy</Link> page.
            </Typography>

            <Typography variant="h6">
              Re-targeting Advertising
            </Typography>

            <Typography>
              Kingsland may use re-targeting advertising to deliver more appropriate content or advertisements to individuals or audiences who have previously visited one of its websites. Google, Facebook and other advertising companies may use digital cookies from your browser and serve you advertisements from the University.
            </Typography>

            <Typography variant="h6">
              Public Forums
            </Typography>

            <Typography>
              The University may employ chat rooms or message boards that form a component of a University website or online learning system. Some systems may enable other users to share your posted information and you should exercise caution when disclosing personal information.
            </Typography>

            <Typography variant="h6">
              Copyright Notice
            </Typography>

            <Typography>
              Kingsland University claims copyright ownership of all information stored on its websites, unless expressly stated otherwise.
            </Typography>

            <Typography>
              Moral rights reside with the author, unless expressly stated otherwise. Contact the author in the first instance if you wish to copy, use or link to a particular page or article.
            </Typography>

            <Typography variant="h6">
              Disclaimer
            </Typography>

            <Typography>
              Kingsland strives to keep information stored on its website, social channels and other digital services up to date, but cannot guarantee the information provided is accurate, current or reliable. The information is provided ‘as is’ with no express or implied warranty. Any mistakes in the information that are brought to our attention will be corrected as soon as possible.
            </Typography>

            <Typography>
              The University reserves the right to make changes to any material on its digital channels at any time including, but not limited to, details relating to courses, admissions, fees and services.
            </Typography>

            <Typography>
              Web links from this site to external, non-University websites should not be construed as implying any commercial or other relationship with and/or endorsement of the external site or its content by Kingsland University, and you are advised to inform yourself as to the privacy statement of those external websites.
            </Typography>

            <Typography variant="h6">
              Google User Data
            </Typography>

            <Typography>
              The Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </Typography>

            <Typography>
              <b>Access</b><br/>
              Kingsland University accesses your profile including Google ID, name, email, Google Classrooms related to Kingsland University 
              and all content therein such as homeworks and grades, and Google Drive Files created by the platform to facilitate an integrated and seamless
              education experience between Google Classroom and the exam checker platform. Most of your profile information is for
              display purposes only and is not stored in our servers.
            </Typography>

            <Typography>
              <b>Uses</b><br/>
              Kingsland University uses Google Classroom to store your homework submissions, automatically submit grades for homeworks, 
              manually evaluate your work and submit grades for exams, retrieve your grades for display, and retrieve the lessons 
              in any Kingsland University-related Google Classrooms for display within the platform.
            </Typography>

            <Typography>
              <b>Storage</b><br/>
              Kingsland University merely acts as a middleman to pre-check your homeworks and exams before submitting 
              your file to Google Classroom for instructor review.
              
              The platform does not store any information from your Google account except for the following circumstances:<br />
              <ul>
                <li>Storage of your homework submission file to be ran against the exam checker tool.</li>
                <li>Storage of your homework submission file to be rendered on the platform if it is an HTML file.</li>
                <li>Temporary storage of your homework submission file for caching purposes.</li>
              </ul>
            </Typography>

            <Typography>
              <b>Sharing</b><br/>
              Kingsland University will never share any information that can be retrieved from your Google Account to third-party providers.
            </Typography>
          </Box>
        </Container>
      </MuiThemeProvider>
    </>
  );
};

export default PrivacyPolicy;
